import { configureStore } from '@reduxjs/toolkit';
import Slice from './Slice';

const store = configureStore({
  reducer: {
    dropdown: Slice,
  },
});

export default store;
